// extracted by mini-css-extract-plugin
export default {"container":"is-weather-guaranteed-footer-component_container__zaCQS","headerText":"is-weather-guaranteed-footer-component_headerText__5vn-0"};